/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Stats_PassingInputs */

const en_course_stats_passing = /** @type {(inputs: Course_Stats_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to pass`)
};

const ja_course_stats_passing = /** @type {(inputs: Course_Stats_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合格基準`)
};

const fr_course_stats_passing = /** @type {(inputs: Course_Stats_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pour réussir`)
};

const de_course_stats_passing = /** @type {(inputs: Course_Stats_PassingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zum Bestehen`)
};

/**
* | output |
* | --- |
* | "to pass" |
*
* @param {Course_Stats_PassingInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_stats_passing = /** @type {((inputs?: Course_Stats_PassingInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Stats_PassingInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_stats_passing(inputs)
	if (locale === "ja") return ja_course_stats_passing(inputs)
	if (locale === "fr") return fr_course_stats_passing(inputs)
	return de_course_stats_passing(inputs)
});